module.exports = __webpack_public_path__ + "media/apps/main/containers/portfolio/Export/Docx/assets/arrow-top-c2d7c89e0d97cea72b09c10cfde55834.png";